import { Modal } from '@atom/mui';

import classes from './teamErrorModal.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  type: string;
}

const TeamErrorModal = ({ open, onClose, type }: Props) => {
  return (
    <Modal
      title={`Cannot delete ${type}`}
      open={open}
      cancelButtonText="OK"
      onCancel={onClose}
      width="sm"
      ConfirmButtonProps={{ sx: { display: `none` } }}
    >
      <div className={classes.modalContainer}>
        {`The ${type} cannot be deleted because it is in use on one or more work. Please remove the ${type} from all work and try again.`}
      </div>
    </Modal>
  );
};

export default TeamErrorModal;
